import { Button, Paper, Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import { TProfileManagerMessagesKeys } from 'Languages/TProfileManagerMessages';
import TestIds from 'Tests/TestIds';
import ButtonLoading from 'Theme/components/ButtonLoading';

export const useStyles = makeStyles(theme => ({
  button: {
    marginRight: 8
  },
  paper: {
    padding: theme.spacing(3),
    paddingBottom: theme.spacing(2),
    maxWidth: 300,
    textAlign: 'center'
  },
  text: {
    marginBottom: theme.spacing(2)
  }
}));

interface Props {
  selectedUserCount: number;
  loading: boolean;
  confirmationMessageId: TProfileManagerMessagesKeys;
  onSubmit: (event: React.FormEvent<HTMLFormElement>) => void;
  onCollapse: () => void;
}

const RemoveUsersConfirmation = ({
  selectedUserCount,
  loading,
  confirmationMessageId,
  onSubmit,
  onCollapse
}: Props) => {
  const classes = useStyles();

  return (
    <form onSubmit={onSubmit} onReset={onCollapse}>
      <Paper classes={{ root: classes.paper }}>
        <Typography variant="body2" classes={{ root: classes.text }}>
          <FormattedMessage
            id={confirmationMessageId}
            values={{ count: selectedUserCount }}
          />
        </Typography>
        <Button
          type="reset"
          size="medium"
          color='inherit'
          classes={{ root: classes.button }}
          data-testid={TestIds.common.snackbar.action.cancel}
        >
          <FormattedMessage id="common.action.cancel" />
        </Button>
        <ButtonLoading
          type="submit"
          size="medium"
          color="primary"
          variant="contained"
          loading={loading}
        >
          <FormattedMessage id="common.action.delete" />
        </ButtonLoading>
      </Paper>
    </form>
  );
};

export default RemoveUsersConfirmation;
